/*
 * File: PatientHomeList.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays list of links on patient home page
 */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { List, ListItem } from "@material-ui/core";
import { Link } from "react-router-dom";
import PatientHomeCards from "./PatientHomeRoutes";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { withRouter } from "react-router";

const styles = theme => ({
  root: {
    padding: 0
  },
  listItem: {
    borderBottom: "1px solid" + theme.palette.common.border
  },
  icon: {
    zoom: 2,
    flex: "0 0"
  },
  title: {
    flex: 1,
    paddingLeft: theme.spacing(1),
    color: theme.palette.text.primary
  },
  flex: {
    display: "flex",
    alignItems: "center"
  },
  list: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  },
  arrow: {
    right: 0,
    position: "absolute"
  }
});

const PatientHomeList = ({ classes, location }) => {
  let basePath = location.pathname.replace("patient_home", "");
  let navLinks = PatientHomeCards.map((item, idx) => {
    return (
      <Link to={basePath + item.path} key={idx} id={item.path}>
        <ListItem className={classes.listItem} key={item.path}>
          <div className={classes.flex}>
            <div className={classes.icon}>{item.icon}</div>
            <div className={classes.title}>{item.title}</div>
            <div className={classes.arrow}>
              <ArrowRightIcon />
            </div>
          </div>
        </ListItem>
      </Link>
    );
  });

  return <List className={classes.list}>{navLinks}</List>;
};

PatientHomeList.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(PatientHomeList));
